import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import ProjectHoldHistoryRow from './ProjectHoldHistoryRow';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormTitle from '../../../library/form/components/FormTitle';
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../library/layout/Index";

const ProjectHoldHistory = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Hold List' />
                    </span>
                </UiTitle>
                {/* <UiAction>
                    <FormButton formObject={formObject} id="newAddButton" ksc="h" rowKey=""
                        action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Add on Hold" />}></FormButton>
                </UiAction> */}
            </UiViewHeading>
            <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr" /></li>
                                <li className='uiColumnCenter uiColumn150' ><SarasTrans value="Reason for Hold" /></li>
                                <li className='uiColumnCenter uiColumn70' ><SarasTrans value="Process" /></li>
                                <li className='uiColumnCenter uiColumn150' ><SarasTrans value="Hold Date" /></li>
                                <li className='uiColumnCenter uiColumn100' ><SarasTrans value="Hold Comment" /></li>
                                <li className='uiColumnCenter uiColumn100' ><SarasTrans value="Is Resumed" /></li>
                                <li className='uiColumnCenter uiColumn150' ><SarasTrans value="Resumed On" /></li>
                                <li className='uiColumnCenter uiColumn100' ><SarasTrans value="Resume Comment" /></li>
                                <li className='uiColumnCenter uiColumn100' ><SarasTrans value="Hold Hrs" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Action" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData.viewRows).map((row, index) => (
                                <li className='uiSearchRow' >
                                    <ProjectHoldHistoryRow formObject={formObject} rowKey={row.rowKey} viewData={row} index={index+1} />
                                </li>
                            ))
                        }
                    </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProjectHoldHistory, "projectHold", "")